// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'

// css
import './index.scss'

// types
interface Error404Props {
    className?: string
    title?: string
    intro?: string
    cta?: {
        label?: string
        url?: string
        external?: boolean
    }
}

export default function Error404({
    className,
    title,
    intro,
    cta
}: Error404Props) {
    return (
        <div className={clsx('page-error-404', className)}>
            <Section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3'>
                            <div className='page-error-404__wrapper'>

                                {title && (
                                    <h1 className='h1'>
                                        {title}
                                    </h1>
                                )}

                                {intro && (
                                    <div
                                        className='lead-paragraph'
                                        dangerouslySetInnerHTML={{ __html: intro }}
                                    />
                                )}

                                {cta && (
                                    <a
                                        href={cta.url}
                                        target={cta.external ? '_blank' : '_self'}
                                        className='button-black'
                                    >
                                        {cta.label}
                                    </a>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </Section>
        </div>
    )
}